import { defineStore } from "pinia";

export const useModalStore = defineStore('modal_store', {
	state: () => ({
		modals: 0,
		overflow: null,
	}),
	actions: {
		open() {
			if (this.modals === 0) {
				this.overflow = document.body.style.overflow;
				document.body.style.overflow = 'hidden';
			}
			this.modals++;
		},
		close() {
			this.modals--;
			if (this.modals === 0) {
				document.body.style.overflow = this.overflow;
			}
		}
	}
});
